import { Link } from "react-router-dom";
import { TOP_CATEGORIES, categoryPath } from "@/data/topCategories";

/**
 * Real <a href> links to the top category pages (/brands/category/{slug}) plus the full directory.
 * Styling comes from the caller so the same list fits the homepage, footer and brand pages.
 */
export default function CategoryLinks({ className = "", linkClassName = "", label = "Browse brands by category" }) {
  return (
    <nav aria-label={label}>
      <ul className={className} style={{ listStyle: "none", margin: 0, padding: 0 }}>
        {TOP_CATEGORIES.map((category) => (
          <li key={category.slug}>
            <Link to={categoryPath(category.slug)} className={linkClassName}>
              {category.label}
            </Link>
          </li>
        ))}
        <li>
          <Link to="/brands" className={linkClassName}>
            All brands
          </Link>
        </li>
      </ul>
    </nav>
  );
}
